
import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

interface ImageUrlFieldProps {
  imageUrl: string;
  setImageUrl: (value: string) => void;
}

const ImageUrlField: React.FC<ImageUrlFieldProps> = ({
  imageUrl,
  setImageUrl,
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="imageUrl">Image URL (Optional)</Label>
      <Input
        id="imageUrl"
        value={imageUrl}
        onChange={(e) => setImageUrl(e.target.value)}
        placeholder="Enter URL for recipe image"
      />
    </div>
  );
};

export default ImageUrlField;
